import { Grid, Typography } from "@mui/material";
import RetractionPerYearLinearCharts from "./RetractionPerYearLinearChart";
import PublicJournalSummaryTable from "./PublicJournalSummaryTable";
import PublisherSummaryBarChart from "./PublisherSummaryBarChart";

function RWAcknowledgement() {
    return (
        <><Typography variant='body1' color="text.secondary" mt={1} align='center'>
            Source data for all charts on this page are Retraction Watch Database and Scitlity PBC Database
        </Typography>
            <Typography variant='body1' color="text.secondary" mt={1} align='center'>
                We would like to acknowledge The Retraction Watch Database, a Crossref service, for providing invaluable data that contributed significantly to our research integrity product.  We appreciate the commitment of Retraction Watch and Crossref to transparency and integrity in scientific reporting.
            </Typography></>
    )
}

function HistoricalDashboard() {
    return (
        <>
            <Typography gutterBottom variant="h3" component="div" sx={{ color: '#003366', fontWeight: 'bold', mt:-5 }}>
                Interactive Dashboards (updated daily)
            </Typography>        
            <PublicJournalSummaryTable />
            <RetractionPerYearLinearCharts />
            <PublisherSummaryBarChart />
            <Grid item xs={12} marginTop={2} marginBottom={2} padding={2}>
                <RWAcknowledgement />
            </Grid>
        </>
    )
}

export default HistoricalDashboard;